export const mobNameKey = (code: string): string => `type.${code}.name`
